import { Route } from 'react-router-dom';

import { PmsCredentialDetailPage } from './pages/pms-credential-detail-page.js';
import { PmsCredentialFormPage } from './pages/pms-credential-form-page.js';
import { PmsCredentialListPage } from './pages/pms-credential-list-page.js';

export function pmsCredentialRoutes(): React.JSX.Element {
  return (
    <>
      <Route path="/pms-credentials" element={<PmsCredentialListPage />} />
      <Route path="/pms-credentials/new" element={<PmsCredentialFormPage />} />
      <Route path="/pms-credentials/:pmsCredentialId/edit" element={<PmsCredentialFormPage />} />
      <Route path="/pms-credentials/:pmsCredentialId" element={<PmsCredentialDetailPage />} />
    </>
  );
}
